import { BroadcastPopupService } from './../../service/broadcast-popup.service';
import { Injectable, inject } from '@angular/core';
import { ByocMissionComponent } from '../mission.component';
import { PopupService } from '@app/shared/popup';

@Injectable({
    providedIn: 'root',
})
export class ByocMissionPopupService {
    private broadcastPopupService = inject(BroadcastPopupService);
    private popupService = inject(PopupService);

    /**
     * Opens popup with component, attaches it to ApplicationRef and renders at the end of <body>
     */
    open(byocMissionId: string, isSubmodal?: boolean): void {
        const popupData = isSubmodal ? { isSubmodal: true } : { missionId: byocMissionId };
        this.popupService.open(ByocMissionComponent, popupData, 'byocMissionPopup');
    }

    /**
     * Close - is fired always when popup closes
     */
    onClose(message: string, data: any): void {
        this.broadcastPopupService.send(message, data);
    }
}
